import React from 'react';
import type { FC } from 'react';

import type { SidebarMenuItem } from '../classes/SidebarMenuItem';
import { SidebarMenuDynamicItem } from './SidebarMenuDynamicItem';

type SidebarMenuDynamicItemsProps = {
    menuItems: Array<SidebarMenuItem>;
};

export const SidebarMenuDynamicItems: FC<SidebarMenuDynamicItemsProps> = ({
    menuItems,
}) => (
    <>
        {menuItems.map((element, key) => (
            <SidebarMenuDynamicItem key={key} sidebarItem={element} />
        ))}
    </>
);
